
export const SkeletonCarousel = () => {
  return (
    <div>
      <div className="titulo titulo__skeleton">
      </div>
      <div className="AmbosBanners AmbosBanners-skeletongrid">
        <div className="Banner Banner__skeleton"></div>
        <div className="Banner Banner__skeleton"></div>
        <div className="Banner Banner__skeleton"></div>
      </div>
    </div>
  )
}
